module.exports = __webpack_public_path__ + "img/1872-Black Codes.97390b31.jpg";